import { makeStyles } from "@mui/styles";
import type { Theme } from "src/theme";

export const useTopBarStyles = makeStyles((theme: Theme) => ({
    root: {
        zIndex: theme.zIndex.drawer + 100,
        boxShadow: "none",
        backgroundColor: "#FFFFFF",
    },
    toolbar: {
        height: "58px",
        paddingRight: theme.spacing(4),
        backgroundColor: "#FFFFFF",
    },
    verticalDivider: {
        height: 30,
        width: 2,
    },
}));
